export enum FareTypeAcronym {
    TOURIST = 'T',   // Turista
    GENERAL = 'G',   // General 
    MEDIA = 'M',     // Media
    STUDENT = 'E',   // Estudiante
    CLIPP = 'C',     // Clipp
    DRIVER = 'O',    // Conductor
    INSPECTOR = 'I', // Inspector
    RECHARGER = 'R',  // Recargador
    PAYMENT_BANK = 'P', // Pago bancario
    EXONERATED = '0'  // Exonerado
}